<template>
  <nx-fullscreen-dialog
      :active="active"
      :title="$t('message.wizard.new.' + entity)"
      @dismiss="$emit('dismiss')">

    <template slot="toolbar-items">
      <v-btn
          @click="create"
          color="accent"
          dark flat
          :loading="loading"
          :disabled="disabled"
      >{{ $t('message.wizard.createBtn') }}</v-btn>
    </template>

    <v-container py-3 fluid class="nx-taxonomy-wizard-body">
      <v-layout wrap fill-height>

        <nx-form class="nx-form" @form="flags = $event" ref="form">
          <div class="nx-form-fieldset">
            <nx-entity-selector
              label="app"
              :customFilters="customFilters"
              :limit="limit"
              entity="socialNetworkApp"
              icon="search"
              :value="value"
              :open-modal-editor=true
              :formatedItems="app"
              @input="onInput"
            ></nx-entity-selector>
          </div>
        </nx-form>

      </v-layout>
    </v-container>

  </nx-fullscreen-dialog>
</template>

<script>
import FullscreenDialog from '@/components/dialogs/FullscreenDialog';
import NxForm from '@/modules/form/Form';
import Loadable from '@/mixins/loadable';
import api from '../api';

export default {
  name: 'nx-social-network-account-facebook-wizard',
  mixins: [Loadable],
  components: {
    [FullscreenDialog.name]: FullscreenDialog,
  },
  props: {
    active: {
      type: Boolean,
    },
    entity: {
      type: String,
    },
    value: {
      type: [Object, Array],
    },
  },
  data() {
    return {
      customFilters: { type: 'facebookApp' },
      limit: 1,
      app: [],
    };
  },
  computed: {
    appId() {
      if (this.app.id === undefined) {
        return null;
      }

      return this.app.id;
    },
    disabled() {
      return this.loading || this.app.id === undefined;
    },
  },
  methods: {
    async create() {
      this.loadingStart();
      const appId = this.appId;
      if (!appId) {
        console.error('No appId configured for twitter accounts');
        return;
      }

      const response = await api.getFacebookAuthUrl(appId);
      console.log('Redirecting to auth url...', response.url);
      this.loadingFinish();
      window.location.href = response.url;
    },
    async onInput(entity) {
      if (!entity) {
        this.app = [];
      } else {
        this.app = entity;
      }
    },
  },
};
</script>
